import { useStyleTag } from '@vueuse/core'

const useCurrentTheme = () => useState('currentTheme', () => 'green-light-green')

export function useTheme() {
  const theme = useCurrentTheme()

  function setCurrentTheme(color?: string) {
    if (color) {
      theme.value = color
    }
  }

  function setBodyHeroTheme(color?: string) {
    if (color) {
      document.body?.classList.add(`theme-${color}`)
    }
  }
  function resetBodyHeroTheme(color?: string) {
    if (color) {
      document.body?.classList.remove(`theme-${color}`)
    }
  }
  function setBodyErrorTheme() {
    document.body?.classList.add(`!bg-(--sand)`)
    document.body?.classList.add(`!text-(--earth-1)`)
  }
  function resetBodyErrorTheme() {
    document.body?.classList.remove(`!bg-(--green-4)`)
  }
  function setBodyFooterTheme() {
    document.body?.classList.add(`!bg-(--green-2)`)
  }
  function resetBodyFooterTheme() {
    document.body?.classList.remove(`!bg-(--sand)`)
    document.body?.classList.remove(`!text-(--earth-1)`)
  }

  const themeClass = computed(() => `theme-${theme.value}`)

  return {
    theme,
    themeClass,
    setCurrentTheme,
    setBodyHeroTheme,
    resetBodyHeroTheme,
    setBodyErrorTheme,
    resetBodyErrorTheme,
    setBodyFooterTheme,
    resetBodyFooterTheme,
  }
}


export function useSetVariables(themeSettings) {
  themeSettings.forEach((theme) => {
    const { handle, variables } = theme
    const className = `theme-${handle}`
    const cssVariables = Object.keys({ ...variables })
      .map((key) => {
        const value = variables[key] !== null ? variables[key] : ''
        return value !== null
          ? `${key}: hsla(${value.h}, ${value.s * 100}%, ${value.l * 100}%, ${value.a});`
          : ''
      })
      .filter((line) => line !== '')
      .join('\n')

    const cssRule = `.${className} {\n${cssVariables}\n}`
    const { load } = useStyleTag(cssRule, { id: className })

    load()

  })
}


export function getThemeVariablesFromHandle(themeSettings, handle) {
  const theme = themeSettings.find((theme) => theme.handle === handle)
  const { variables } = theme
  const cssVariables = Object.keys({ ...variables })
    .map((key) => {
      const value = variables[key] !== null ? variables[key] : ''
      return value !== null
        ? `${key}: hsla(${value.h}, ${value.s * 100}%, ${value.l * 100}%, ${value.a});`
        : ''
    })
    .filter((line) => line !== '')
    .join('\n')
  return cssVariables
}